module.exports = __webpack_public_path__ + "media/bootstrap-icons/sticky-fill-c387da3d.svg";